import { useSearch } from "@tanstack/react-router";
import { Text } from "styles/utility-components";

import { Card, Page } from "./authPageStyles";
import { CheckYourEmailCard } from "./CheckYourEmailCard";
import { StotlesLogo } from "./StotlesLogo";

/**
 * Landing page for a social sign-in whose provider didn't confirm the user's email address. The
 * auth-service withholds the session, emails a confirmation link and redirects here with the
 * address (see social-email-verification.ts) — so the email comes from the query string, not a
 * session, because at this point there isn't one.
 */
export function BetterAuthVerifyEmailPage() {
  // Bounded + format-checked by the route's validateVerifyEmailSearch. `strict: false` lets it
  // resolve to undefined when rendered outside the route (e.g. tests).
  const { email } = useSearch({ strict: false });

  // Without an address there's nothing to display or resend to. Reachable only by hand-editing the
  // URL, so keep it a plain dead end rather than inventing a recovery flow.
  if (!email) {
    return (
      <Page>
        <Card centred>
          <StotlesLogo />
          <Text h1 color="sysDestructiveDefault">
            Confirm your email address
          </Text>
          <Text color="sysTextSecondary">
            We&apos;ve emailed you a link to confirm your address. Open it to finish signing in.
          </Text>
        </Card>
      </Page>
    );
  }

  return <CheckYourEmailCard email={email} reason="social" />;
}
